import React from "react";
import emailjs from "emailjs-com";
import "./Contact.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCheck,
  faMapMarkerAlt,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import Slide from "react-reveal/Slide";
const Contract = () => {
  function sendEmail(e) {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_6lesoze",
        "template_z5o2gxs",
        e.target,
        "user_w17a8QID1PX2sB9GXf2e2D"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  }
  return (
    <section class="contact pb-5">
      <h2 class="title text-center" id="Contact">
        Contact me
      </h2>
      <div class="contact-content row mr-0">
        <div class="column left col-md-6 ml-4">
          <Slide top>
            <div class="text">Get in Touch</div>
            <p>
              I have just started my career, I don’t have practical
              achievements, but I really want to practically explore and
              experience my potential by delivering the best services to the
              company. It will be my honor to work with you and this
              organization.
            </p>
            <div class="icons">
              <div class="d-flex align-items-center">
                <div className="contact-icons">
                  <FontAwesomeIcon
                    className="contact-icon mr-3"
                    icon={faUserCheck}
                  />
                </div>
                <div class="info">
                  <div class="head">Name</div>
                  <div class="sub-title">Hadid Billa</div>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div className="contact-icons">
                  <FontAwesomeIcon
                    className="contact-icon mr-3"
                    icon={faMapMarkerAlt}
                  />
                </div>
                <div class="info">
                  <div class="head">Address</div>
                  <div class="sub-title">Jessore, Khulna</div>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div className="contact-icons">
                  <FontAwesomeIcon
                    className="contact-icon mr-3"
                    icon={faEnvelope}
                  />
                </div>
                <div class="info">
                  <div class="head">Email</div>
                  <div class="sub-title">hadidbilla449@gmail.com</div>
                </div>
              </div>
            </div>
          </Slide>
        </div>
        <div class="column right col-md-5">
          <Slide bottom>
            <div class="text">Message me</div>
            <form
              onSubmit={sendEmail}
              class="contact-form"
              action="#"
              method="POST"
            >
              <div class="fields">
                <div class="field name">
                  <input type="text" class="fullname" placeholder="Name" />
                </div>
                <div class="field email">
                  <input type="text" class="email-input" placeholder="Email" />
                </div>
              </div>
              <div class="field">
                <input type="text" class="subject" placeholder="Subject" />
              </div>
              <div class="field textarea">
                <textarea
                  class="message"
                  cols="30"
                  rows="10"
                  placeholder="Message.."
                ></textarea>
              </div>
              <div class="button-area">
                <button class="send-msg" type="submit" name="send">
                  Send message
                </button>
              </div>
            </form>
          </Slide>
        </div>
      </div>
    </section>
  );
};

export default Contract;
